(function () {
    // Function to safely apply accessibility attributes to the reCAPTCHA textarea
    function fixRecaptchaA11y(textarea) {
        if (textarea && !textarea.labels?.length && !textarea.hasAttribute('aria-label')) {
            textarea.setAttribute('aria-label', 'Google reCAPTCHA Verification Response');
            textarea.setAttribute('aria-hidden', 'true');
            textarea.setAttribute('aria-readonly', 'true');
        }
    }

    // Observe the DOM to apply the patch the instant Google injects the element
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    // Check if the node itself or any child is the reCAPTCHA response textarea
                    if (node.classList?.contains('g-recaptcha-response')) {
                        fixRecaptchaA11y(node);
                    } else {
                        const nestedTextarea = node.querySelector?.('.g-recaptcha-response');
                        if (nestedTextarea) fixRecaptchaA11y(nestedTextarea);
                    }
                }
            });
        });
    });

    // Start watching the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback execution check once the page completely finishes loading
    window.addEventListener('load', () => {
        document.querySelectorAll('.g-recaptcha-response').forEach(fixRecaptchaA11y);
    });
})();